import { render } from "./PreActionPhotos.vue?vue&type=template&id=1e37ab4e&scoped=true"
import script from "./PreActionPhotos.vue?vue&type=script&lang=js"
export * from "./PreActionPhotos.vue?vue&type=script&lang=js"

import "./PreActionPhotos.vue?vue&type=style&index=0&id=1e37ab4e&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e37ab4e"]])

export default __exports__